import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { updateUserPassword } from '@/api/system/user/user';
import md5 from 'js-md5';
export default {
  props: ['keyValueMode', 'showDialog'],
  data: function data() {
    var _this = this;

    var LxStr = function LxStr(str) {
      var arr = str.split('');
      var flag = true;

      for (var i = 1; i < arr.length - 1; i++) {
        var firstIndex = arr[i - 1];
        var secondIndex = arr[i];
        var thirdIndex = arr[i + 1];
        thirdIndex - secondIndex === 1;
        secondIndex - firstIndex === 1;

        if (thirdIndex - secondIndex === 1 && secondIndex - firstIndex === 1) {
          flag = false;
        }
      }

      return flag;
    };

    var validatePass = function validatePass(rule, value, callback) {
      if (!value) {
        callback(new Error('请输入密码'));
      } else {
        var reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@#!%*?&._])[A-Za-z\d$@#!%*?&._]{8,16}/;

        if (value.length < 8 || value.length > 16) {
          callback(new Error('密码长度必须为8~16位'));
        } else if (!reg.test(value)) {
          callback(new Error('密码必须同时包含大小写字母、数字、特殊字符'));
        } else if (!LxStr(value)) {
          callback(new Error('数字不能连续三位'));
        } else {
          callback();
        }
      }
    };

    var validatePass2 = function validatePass2(rule, value, callback) {
      if (!value) {
        callback(new Error('请输入确认密码'));
      } else if (value !== _this.childData.userPwd) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };

    return {
      rules: {
        userPwd: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }, {
          validator: validatePass,
          trigger: 'blur'
        }],
        cifrmUserPwd: [{
          required: true,
          message: '请输入确认密码',
          trigger: 'change'
        }, {
          validator: validatePass2,
          trigger: 'blur'
        }]
      },
      userId: 0,
      childData: {
        userId: 0,
        userPwd: ''
      }
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs['dataForm'].resetFields();
        this.childData = this.keyValueMode;
        this.childData.userPwd = '';
      }
    }
  },
  created: function created() {
    this.childData = this.keyValueMode;
    this.childData.userPwd = '';
  },
  methods: {
    handCreate: function handCreate() {
      var _this2 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          var childDataClone = JSON.parse(JSON.stringify(_this2.childData));
          _this2.childData.userPwd = md5(childDataClone.userPwd);
          updateUserPassword(_this2.childData.userId, _this2.childData.userPwd).then(function () {
            _this2.$emit('handCanclePwd');

            _this2.Alert({
              alertType: 'update'
            });
          });
        } else {
          _this2.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCanclePwd');
    }
  }
};